import { useAppDispatch } from '../../core/hooks/storeHooks';
import { isCtrlKey } from '../../core/utils/keys/keys';
import {
  arrowKeyOnCell,
  enterKeyOnCell,
  openCellEditor,
} from '../redux/sagas/views/viewsActions';
import { ReturnTypeofSheetSectionsSelector } from '../selectors/sheetUiSelector';
import { getVisibleSelectionAreas } from '../helpers/selectionHelper';
import { UseGridOperations } from './useGridOperations';
import { WindowSizes } from '../../windows/constants/windowSizes';

export const isArrowKey = (key: string) =>
  key === 'arrowup' ||
  key === 'arrowright' ||
  key === 'arrowdown' ||
  key === 'arrowleft';

export default (
  sheetId: string,
  windowX: number,
  windowY: number,
  windowWidth: number,
  windowHeight: number,
  // windowGeometry: WindowGeometry,
  props: ReturnTypeofSheetSectionsSelector,
  gridWidth: number,
  isRtl: boolean,
  openContextMenu: UseGridOperations['openContextMenu']
) => {
  const dispatch = useAppDispatch();
  const onKeyDown = (e: React.KeyboardEvent) => {
    const ctrlKey = isCtrlKey(e.ctrlKey, e.metaKey);
    const shiftKey = e.shiftKey;
    const key = e.key.toLowerCase();
    console.log('key', key);

    if (key === 'contextmenu') {
      const area = getVisibleSelectionAreas(
        props,
        props.activeCellArea,
        gridWidth,
        isRtl
      )[0];
      const top =
        windowY +
        props.formulaBarHeight +
        props.groupBarHeight +
        WindowSizes.controlBarHeight;

      const left = windowX + props.rowGroupBarWidth;
      if (area.height > 0 && area.width > 0) {
        openContextMenu(undefined, {
          clientX: left + area.x,
          clientY: top + area.y,
        });
      }
    } else if (key === 'enter') {
      dispatch(
        enterKeyOnCell({
          sheetId,
          windowWidth,
          windowHeight,
        })
      );
    } else if (ctrlKey && (key === 'c' || key === 'x')) {
      // dispatch(
      //   handleCellOperationsAc({
      //     sheetId,
      //     operationData: {
      //       op: CellOperations.Copy,
      //       isCut: key === 'x',
      //     },
      //   })
      // );
    } else if (ctrlKey && key === 'v') {
      // dispatch(
      //   handleCellOperationsAc({
      //     sheetId,
      //     operationData: {
      //       op: CellOperations.Paste,
      //     },
      //   })
      // );
    } else if (isArrowKey(key)) {
      // TODO: Dispatch arrow key
      dispatch(
        arrowKeyOnCell({
          sheetId,
          key,
          ctrlKey,
          shiftKey,
          windowWidth,
          windowHeight,
        })
      );
    } else {
      dispatch(
        openCellEditor({
          sheetId,
          key,
        })
      );
    }
  };
  // [sheetId, windowWidth, windowHeight]
  // );

  return onKeyDown;
};
